import { render, staticRenderFns } from "./StockTrfPrintDetails_Total.vue?vue&type=template&id=b27e0e22&"
import script from "./StockTrfPrintDetails_Total.vue?vue&type=script&lang=js&"
export * from "./StockTrfPrintDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports